import { render } from "./PlaytestReviewPage.vue?vue&type=template&id=528bc2a6&scoped=true"
import script from "./PlaytestReviewPage.vue?vue&type=script&lang=js"
export * from "./PlaytestReviewPage.vue?vue&type=script&lang=js"

import "./PlaytestReviewPage.vue?vue&type=style&index=0&id=528bc2a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528bc2a6"]])

export default __exports__